import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
import { Chart } from 'chart.js/auto';
import * as dateFns from 'chartjs-adapter-date-fns';

Chart.register(dateFns);

const ChartComponent = ({ priceHistory }) => {
  const { symbol } = useParams();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (priceHistory) {
      const timeSeries = priceHistory['Time Series (Daily)'];
      const labels = Object.keys(timeSeries).reverse();
      const data = Object.values(timeSeries)
        .map((item) => item['4. close'])
        .reverse();

      const chartData = {
        labels: labels,
        datasets: [
          {
            label: `${symbol} Close Price`,
            data: data,
            borderColor: '#000',
            fill: true,
            pointRadius: 0,
            pointHoverRadius: 0,
          },
        ],
      };

      setChartData(chartData);
    }
  }, [priceHistory, symbol]);

  const options = {
    plugins: {
      legend: {
        onClick: (e) => e.stopPropagation(),
        display: false,
      },
    },
    elements: {
      line: {
        tension: 0.4,
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
          displayFormats: {
            day: 'MMM dd',
          },
        },
        ticks: {
          color: '#000',
          font: {
            family: 'Lexend, sans-serif',
          },
          fontFamily: 'Lexend, sans-serif',
        },
      },
      y: {
        ticks: {
          color: '#000',
          font: {
            family: 'Lexend, sans-serif',
          },
        },
      },
    },
    tooltips: {
      enabled: false,
    },
  };

  return chartData ? (
    <Line data={chartData} options={options} />
  ) : (
    <div>Loading chart data...</div>
  );
};

export default ChartComponent;
